/**
 * @author       esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  colors.ts
 */

export const lightestBackground = '#f8f8fa'
export const lightBackground = '#f3f5f6'
export const backgroundGray = '#e6e8e9'
export const blue = '#2e64e2'
export const lightCyan = '#f1faf8'
export const darkBlue = '#2a4291'
export const darkerBlue = '#2452bc'
export const lightBrown = '#726F6C'
export const gray5 = '#f6f6f6'
export const gray10 = '#eeeef0'
export const gray30 = '#dfe2e4'
export const gray50 = '#b9bdc2'
export const gray60 = '#8c939b'
export const gray70 = '#697179'
export const gray90 = '#4e5865'
export const green = '#3cb86c'
export const greenScore = '#068047'
export const walkScoreLightGreen = '#80c138'
export const orange = '#fe9c27'
export const ink = '#2a2b2c'
export const inkLight = '#949595'
export const newGreen = '#22801c'
export const slate = '#d5d9dc'
export const slateDarker = '#4f5c68'
export const slateLight = '#e4e7e9'
export const legacyPink = '#ff0082'
